
import React from "react";
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import SellerResponseInput from "../../messages/SellerResponseInput";
import { Message } from "@/types/message";

interface SellerResponseContentProps {
  onPasteSellerResponse: (content: string) => void;
  isGenerating: boolean;
  hasMessages: boolean;
  lastAIMessage?: Message | null;
  isFlightClaim?: boolean;
}

const SellerResponseContent = ({
  onPasteSellerResponse,
  isGenerating,
  hasMessages,
  lastAIMessage,
  isFlightClaim = false
}: SellerResponseContentProps) => {
  const title = isFlightClaim ? "Paste Airline's Response" : "Paste Seller's Response";
  const description = isFlightClaim 
    ? "When the airline replies, paste their response here"
    : "When the merchant replies, paste their response here";

  return (
    <>
      <CardHeader>
        <CardTitle className="text-lg">
          {title}
        </CardTitle>
        <CardDescription>
          {description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <SellerResponseInput 
          onPasteSellerResponse={onPasteSellerResponse} 
          isGenerating={isGenerating}
          hasMessages={hasMessages}
          lastAIMessage={lastAIMessage}
          hideTitle={true} // Hide the duplicate title
          isFlightClaim={isFlightClaim}
        />
      </CardContent>
    </>
  );
};

export default SellerResponseContent;
